//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {submitAppointment} from "../../api/delivery";

export default {
  name: "delivery-appointment",
  data() {
    return {
      saving: false,
      showSaveBtn: false,
      deliverRecord: {
        name: '', mobile: ''
      },
      deliveryPlan: {},
      dateStr: '',
      timeStr: '',
      show: false,
      showTime: false,
      planId: 0,
      numActionSheet: false,
      visitModeActionSheet: false,
      recordId: 0,
      mindate: new Date(),
      maxdate: new Date(),
      errorTitle: ''
    }
  },
  methods: {
    formatDate(date) {
      var m = date.getMonth() + 1;
      if (m < 10) {
        m = '0' + m;
      }
      var d = date.getDate();
      if (d < 10) {
        d = '0' + d;
      }
      return `${date.getFullYear()}-${m}-${d}`;
    },
    onConfirm(date) {
      this.show = false;
      this.date = this.formatDate(date);
      this.deliverRecord.deliveryTime = this.date;
      this.getDayCount(this.date);
      if (this.time) {
        this.getDayTimeCount();
      }
    },
    onNumActionSheet(action, index) {
      this.deliverRecord.visitorsNum = action.name;
      this.numActionSheet = false;
    },
    onVisitModeActionSheet(action, index) {
      if (action.name === '自驾') {
        this.deliverRecord.visitMode = 0
      } else if (action.name === '公共交通') {
        this.deliverRecord.visitMode = 1
      } else if (action.name === '步行') {
        this.deliverRecord.visitMode = 2
      }
      this.deliverRecord.visitModeStr = action.name;
      this.visitModeActionSheet = false;
    },

    getPlan() {
      if (!this.planId > 0) {
        return
      }
      let vm = this;
      abp.ajax.get('/api/services/app/Delivery/GetDeliveryPlanById?id=' + this.planId).then(res => {
        this.deliveryPlan = {};
        this.deliveryPlan = res.data.result;
        this.mindate = new Date(this.deliveryPlan.deliveryStartTimeStr);
        this.maxdate = new Date(this.deliveryPlan.deliveryEndTimeStr);
        const now = new Date();
        if (vm.deliveryPlan.appointmentStartTime != null && vm.deliveryPlan.appointmentEndTime != null) {
          let end = vm.$moment(vm.deliveryPlan.appointmentEndTime).add(1, "days");
          this.showSaveBtn = (vm.$moment(now).isAfter(vm.deliveryPlan.appointmentStartTime) && vm.$moment(now).isBefore(end));
        }
        if (!this.showSaveBtn) {
          this.errorTitle = '不在预约交付开放时段';
        }

      }).finally(() => {

      })
    },
    getTimes(startTime, endTime) {

      var str = startTime + '-' + endTime;
      let openTime = [];
      openTime.push(str);

      let y = new Date().getFullYear();
      let m = new Date().getMonth() + 1;
      let d = new Date().getDate();
      let start = [], end = []; //start起始时间数组，end结束时间数组
      for (let i = 0, len = openTime.length; i < len; i++) { //将时间字符串转换成日期格式并存入开始时间数组和结束时间数组
        let [s, e] = openTime[i].split('-');
        start.push(new Date(y + '/' + m + '/' + d + ' ' + s));
        end.push(new Date(y + '/' + m + '/' + d + ' ' + e));
      }
      let list = [];

      function formatTime(time) { //时间为个位数则补零
        return time < 10 ? '0' + time : time;
      }

      for (let i = 0, len = start.length; i < len; i++) {
        let len2 = (end[i].getTime() - start[i].getTime()) / (60 * 60 * 1000); //计算各子区间以半小时为间隔拆分后的数组长度
        for (let j = 0; j < len2; j++) {
          if (start[i].getTime() + 30 * 60 * 1000 <= end[i].getTime()) {
            //将各子区间日期按半小时递增转换为时间并存入list数组
            let ss = new Date(start[i].getTime() + 60 * 60 * 1000 * j),
                ee = new Date(start[i].getTime() + 60 * 60 * 1000 * (j + 1));
            list.push([formatTime(ss.getHours()) + ':' + formatTime(ss.getMinutes()), formatTime(ee.getHours()) + ':' + formatTime(ee.getMinutes())]);
          }
        }
      }
      list = list.map(item => {
        return item.join('-');
      });

      this.list.push(...list);
    },
    setTimeValue(val) {
      this.time = val;
      this.showTime = false;
      this.getDayTimeCount();
    },
    getDayCount() {
      abp.ajax.get('/api/services/app/DeliveryRecord/GetDayCount?planId=' + this.planId + '&date=' + this.date).then(res => {
        this.dayCount = res.data.result;
        this.dateStr = this.date + '(' + '已预约：' + this.dayCount + '人' + ')';
      })
    },
    getDayTimeCount() {
      abp.ajax.get('/api/services/app/DeliveryRecord/GetDayTimeCount?planId=' + this.planId + '&date=' + this.date + '&time=' + this.time).then(res => {
        this.timeCount = res.data.result;
        if (this.time === '上午') {
          this.timeStr = this.time + '  ' + '(' + this.timeCount + '/' + this.deliveryPlan.forenoonCount + ')';
        } else if (this.time === '下午') {
          this.timeStr = this.time + '  ' + '(' + this.timeCount + '/' + this.deliveryPlan.afternoonCount + ')';
        } else {
          this.timeStr = this.time + '  ' + '(' + this.timeCount + '/' + this.deliveryPlan.hourlyNumber + ')';
        }
      })
    },

    getMember() {
      const vm = this;
      this.$store.dispatch({
        type: 'member/getMyMember'
      }).then(() => {
        vm.memberInfo = {
          id: 0,
          associateType: 'MemberIdentityImages',
          addAttrIds: [],
          delAttrIds: [],
        }
        vm.memberInfo = vm.$store.state.member.memberInfo;

        this.deliverRecord.memberId = vm.memberInfo.id;
        this.deliverRecord.name = vm.memberInfo.name
        this.deliverRecord.mobile = vm.memberInfo.phoneNumber

      }).finally(() => {
        this.$toast.clear();
      });
    },

    /*提交预约*/
    onSubmitAppointment() {
      const vm = this;

      if (!vm.deliverRecord.visitorsNum) {
        vm.$toast('请选择到访人数')
        return
      }
      vm.deliverRecord.time = vm.time;
      vm.saving = true;
      submitAppointment(this.deliverRecord).then(res => {
        this.$toast.success('预约成功')
        this.$router.replace({path: '/my-appoint'})
      }).finally(() => {
        vm.saving = false
      })
    },

    getRecordById() {
      const vm = this;
      abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryRecordById?id=' + this.recordId).then(res => {
        // vm.deliverRecord = {}
        vm.deliverRecord = res.data.result;
        if (vm.deliverRecord.content == null) {
          vm.deliverRecord.content = '';
        }
        if (!vm.deliverRecord.visitorsNum) {
          vm.deliverRecord.visitorsNum = '1人'
        }
        this.planId = vm.deliverRecord.planId;
        this.date = vm.deliverRecord.deliveryTimeStr;
        this.dateStr = this.date;
        this.time = vm.deliverRecord.time;
        this.timeStr = this.time;

        this.getPlan();

        this.getMember();
        // this.getEmergencyContactInfo();
      });
    },
  },
  created() {
    this.recordId = parseInt(this.$route.params.recordId) || 0;
    this.getRecordById();
  }
}
